import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { configurationApi, type ConfigurationItem } from '../../api/configuration';

export function SettingsManagerPage() {
  const [items, setItems] = useState<ConfigurationItem[]>([]);
  const [error, setError] = useState('');
  const [key, setKey] = useState('');
  const [value, setValue] = useState('');

  function load() {
    void configurationApi.listConfig().then((r) => setItems(r.items)).catch((e) => setError(String(e)));
  }

  useEffect(() => { load(); }, []);

  async function handleCreate(e: React.FormEvent) {
    e.preventDefault();
    try {
      await configurationApi.createConfig({ key, value, scope: 'tenant', category: 'platform', scope_id: 'default' });
      setKey('');
      setValue('');
      load();
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/configuration" className="text-sm text-blue-600 hover:underline">← Configuration Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Configuration Settings</h1>
      <form onSubmit={(e) => void handleCreate(e)} className="mt-4 flex flex-wrap gap-2">
        <input value={key} onChange={(e) => setKey(e.target.value)} placeholder="key" className="rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" required />
        <input value={value} onChange={(e) => setValue(e.target.value)} placeholder="value" className="rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" required />
        <button type="submit" className="rounded bg-blue-600 px-4 py-2 text-white">Add</button>
      </form>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <table className="mt-6 w-full text-left text-sm">
        <thead><tr className="border-b dark:border-slate-700"><th className="py-2">Key</th><th>Value</th><th>Scope</th><th>Category</th></tr></thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id} className="border-b dark:border-slate-800">
              <td className="py-2 font-mono">{item.key}</td>
              <td>{JSON.stringify(item.value)}</td>
              <td>{item.scope}</td>
              <td>{item.category}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
